import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from '../components/ui/button';
import { classes } from '../mockData';

const Home = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays on mount
    if (videoRef.current) {
      videoRef.current.play().catch(err => console.log('Video autoplay prevented:', err));
    }
  }, []);
  const services = [
    {
      title: 'Signature Kurse',
      description: 'Neue und unbegrenzte Kurse exklusiv bei POSITIV. Entwickelt für das Individuum. Angetrieben von der Gemeinschaft.',
      image: '/images/workout.jpg',
      link: '/classes'
    },
    {
      title: 'Personal Training',
      description: 'Präzisionsbasiertes 1:1 Personal Training mit zertifizierten Coaches, die sich der Maximierung Ihres Potenzials widmen.',
      image: '/images/personal-training.jpg',
      link: '/personal-training'
    },
    {
      title: 'Spa & Wellness',
      description: 'Entspannen. Regenerieren. Erleben Sie alles im Spa, wo innovative Behandlungen den Körper auf zellulärer Ebene verjüngen.',
      image: '/images/spa-header-image.jpg',
      link: '/spa'
    }
  ];

  const regeneration = [
    {
      title: 'Das Spa bei POSITIV',
      description: 'Entspannen. Regenerieren. Erleben Sie alles im Spa, wo innovative Behandlungen den Körper auf zellulärer Ebene verjüngen.',
      image: 'https://images.unsplash.com/photo-1562751362-404243c2eea3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzc3xlbnwwfHx8fDE3NjI4Njk0OTV8MA&ixlib=rb-4.1.0&q=85',
      link: '/spa'
    },
    {
      title: 'Exklusive Annehmlichkeiten',
      description: 'Zugang zu makellosen Umkleideräumen, Saunen und Dampfbädern, ausgestattet mit Eukalyptus-Handtüchern und Premium-Produkten.',
      image: 'https://images.unsplash.com/photo-1458501534264-7d326fa0ca04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx3ZWxsbmVzc3xlbnwwfHx8fDE3NjI4Njk0OTV8MA&ixlib=rb-4.1.0&q=85',
      link: '/spa'
    },
    {
      title: 'Ikonische Räume',
      description: 'Jeder Club ist mit preisgekrönter Präzision gestaltet, um unsere High-Performance-Community widerzuspiegeln.',
      image: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBneW18ZW58MHx8fHwxNzYyODY5NDgyfDA&ixlib=rb-4.1.0&q=85',
      link: '/membership'
    }
  ];

  return (
    <div className="bg-black">
      {/* Hero Section with Image Background */}
      <section className="relative h-screen flex items-center justify-center text-white overflow-hidden">
        {/* Image Background */}
        <img
          src="/images/header-image.jpg"
          alt="POSITIV Header"
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        {/* Translucent Overlay with gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
        <div className="absolute inset-0 bg-black/20 backdrop-blur-[0.5px]" />
        
        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-6 uppercase drop-shadow-2xl">
            WERDE TEIL DER<br />POSITIV <span className="inline-block bg-[#c49806] px-4 py-2 font-black">WOLNZACH</span><br />FITNESS & WELLNESSGRUPPE
          </h1>
          <p className="text-lg md:text-xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
            Wechsle ganz einfach zur Positiv Gruppe und erhalte exklusiv für den Standort bis zu 3 Monate Gratis Training!
Ganz einfach eintragen und direkt durchstarten
          </p>
        </div>
        <button 
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
          className="absolute bottom-12 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-white/60 hover:bg-white/10 transition-all animate-bounce backdrop-blur-sm z-10"
        >
          <ChevronDown className="w-6 h-6 text-white" />
        </button>
      </section>

      {/* Membership Section */}
      <section className="relative min-h-screen flex items-center">
        <div className="absolute inset-0">
          <img 
            src="/images/positiv-training.jpg"
            alt="Membership"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>
        <div className="relative z-10 max-w-[1920px] mx-auto px-6 lg:px-12 py-24 w-full">
          <div className="max-w-2xl bg-white p-12 lg:p-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-black">
              Eine Mitgliedschaft.<br />Grenzenloses Potenzial.
            </h2>
            <p className="text-lg text-black/80 mb-8 leading-relaxed">
              Unbegrenzte Signature-Kurse, präzisionsbasiertes Personal Training und exklusive Annehmlichkeiten zur Erholung und Regeneration.
            </p>
            <Button asChild size="lg" className="bg-black text-white hover:bg-black/90 h-12 px-8">
              <Link to="/membership">
                Mitgliedsvorteile entdecken
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Luxury Section */}
      <section className="relative min-h-screen flex items-center bg-white text-black">
        <div className="absolute inset-0">
          <img 
            src="/images/tretmill.jpg"
            alt="Luxury"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative z-10 max-w-[1920px] mx-auto px-6 lg:px-12 py-24 w-full text-center">
          <h2 className="text-4xl lg:text-6xl font-bold mb-6">
            Wo Fitness und Wellness aufeinandertreffen
          </h2>
          <p className="text-xl text-black/80 mb-12 max-w-3xl mx-auto">
            Saubere Räume und regenerative Annehmlichkeiten, die Ihre Leistung vorantreiben.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="bg-black py-24">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <Link 
                key={index}
                to={service.link}
                className="group relative overflow-hidden aspect-[3/4] bg-black"
              >
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-90" />
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h3 className="text-2xl font-bold mb-3">{service.title}</h3>
                  <p className="text-white/80 text-sm leading-relaxed mb-4">{service.description}</p>
                  <span className="inline-flex items-center text-sm font-medium group-hover:gap-2 transition-all">
                    Mehr erfahren
                    <ArrowRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Regeneration Grid */}
      {/* <section className="bg-black py-24">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {regeneration.map((item, index) => (
              <Link 
                key={index}
                to={item.link}
                className="group relative overflow-hidden aspect-[3/4] bg-black"
              >
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-90" />
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h3 className="text-2xl font-bold mb-3">{item.title}</h3>
                  <p className="text-white/80 text-sm leading-relaxed mb-4">{item.description}</p>
                  <span className="inline-flex items-center text-sm font-medium group-hover:gap-2 transition-all">
                    Mehr entdecken
                    <ArrowRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section> */}

      {/* App Section */}
      <section className="relative py-32 bg-white text-black">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-5xl lg:text-6xl font-bold mb-6">
                POSITIV Starterkit
              </h2>
              <p className="text-xl text-black/80 mb-8 leading-relaxed">
                Du willst Deinem Körper und Geist etwas Gutes tun? Bei uns bekommst Du alles, was Du für einen erfolgreichen Start in Dein neues Fitnessleben brauchst.
              </p>
              <Button size="lg" className="bg-black text-white hover:bg-black/90 h-12 px-8">
                Eine Woche kostenlos testen
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </div>
            <div className="relative aspect-square">
              <img 
                src="/images/starter.jpg"
                alt="POSITIV"
                className="w-full h-full object-cover rounded-sm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-32 bg-black text-white">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl lg:text-6xl font-bold mb-6">
            Bereit, Ihr Potenzial zu entfalten?
          </h2>
          <p className="text-xl text-white/80 mb-12">
            Besuchen Sie einen Club oder werden Sie noch heute Mitglied.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Button asChild size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-black h-14 px-10 text-base">
              <Link to="/membership">Mitglied werden</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
